export default __webpack_public_path__ + "static/media/enjambre-main.d989fec0.jpg";